<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-bottom: 40px;">About the Author</h1>
<p>Stephen Conroy has lived his entire life in the Capital Region in Upstate New York and is proud to produce his first published book, while incorporating some local ties within the story. He is married and has two young daughters with his wife, Nicole. The story started forming listening to his dad tell campfire stories on their summer vacations to help lead the development of this story.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6e4185d0